import Api from './Api';

class LogicBaseBlockApi extends Api {
  url = 'logicbaseblocks';
}

const singleton = new LogicBaseBlockApi();
export default singleton;
